module.exports = __webpack_public_path__ + "resources/img/main_banner_cloud03.50911a50ef0928ce2b3f2b87edf3cf61.png";